(function() {

	'use strict';

	angular.module( 'showcase' ).controller( 'showcaseController',
			['$scope','$rootScope','$timeout','$sce','$q','$ApiHandler','$interpolate','$templateCache','$http','gettextCatalog','wallpreview','Notification','showcaseEngineModifier',
	function( $scope,  $rootScope,  $timeout,  $sce,  $q,  $ApiHandler,  $interpolate,  $templateCache,  $http,  gettextCatalog,  wallpreview,  Notification,  showcaseEngineModifier ) {

		showcaseEngineModifier.setEnv( "$scope", $scope );

		$scope.currentstate = null;
		setCurrentState( 'initial' );

		var startfunctions = {};
		var showfunctions = {};
		var endfunctions = {};
		var globalfunctions = {};
		
		showcaseEngineModifier.setEnv( "globalfunctions", globalfunctions );

		var backgroundLoopInterval = setInterval( backgroundLoopFn, 1000 );

		$(document).on( 'keyup', onKeyUp );
		$scope.$on( "$destroy", function(){
			$(document).off( 'keyup', onKeyUp );
			clearInterval( backgroundLoopInterval );
		});

		function onKeyUp( event ) {
			console.debug( "onKeyUp() ::", event );
			if (event.keyCode == 27) { // ESC
				$timeout(function() {
					$scope.close_help();
					$scope.close_zoom();
					$scope.wallpreview && $scope.wallpreview.close();
				});
			}
		}

		function setCurrentState( state ) {
			$rootScope.$broadcast( "currentStateChanged", state, $scope.currentstate );
			$scope.currentstate = state;
		}

		initHelp();
		initZoom();
		wallpreview.init( $scope );
		//initWallPreview();

		var slides;

		$rootScope.ready.then(function( _slides ) {
			
			console.log( "Loaded slides", _slides );

			var settings = $rootScope.settings;

			// Järjestetty lista dioista
			$scope.slides = slides = _slides;

			// Aiemman nimeämiskäytännön tueksi
			var oeuvres = $scope.oeuvre_list = slides;
			
			
			$scope.methods = $rootScope.properties_list.methods;


			$scope.asset_url    = window.SHOWCASE_ASSETS_URL;
			setCurrentState( 'start' );
			$scope.swipe_action_in_progress = false;

			$scope.displayname = settings.global.display_name;
			
			$scope.start = {};
			$scope.start['start_action']      = buildFunctionQueue($rootScope.settings.views.start.start_action,startfunctions);
			$scope.start['cancel_action']     = buildFunctionQueue($rootScope.settings.views.start.cancel_action,startfunctions);
			$scope.start['initialize_action'] = buildFunctionQueue($rootScope.settings.views.start.initialize_action,startfunctions);
			$scope.start['timeout_action']    = buildFunctionQueue($rootScope.settings.views.start.timeout_action,startfunctions);
			$scope.start['timeouttimems']     = $rootScope.settings.views.start.timeouttimems;
			$scope.start['transition']        = $rootScope.settings.views.start.transition;
			
			for (var x in $scope.start) {
				if ($rootScope.settings.views.start[ x+'_icon' ] != null) {
					$scope.start[x].icon = $rootScope.settings.views.start[ x+'_icon' ];
				}
			}
			
			console.log( "Compiled view.start settigs", $scope.start );
			// $scope.start.initialize_action();// Siirretty lopun $timoeut'n sisään 1.7.2021 -m
			
			var opts_show = $rootScope.settings.views.show;

			$scope.show = {};
			$scope.show['swipeleft_action']        = buildFunctionQueue($rootScope.settings.views.show.swipeleft_action,showfunctions);
			$scope.show['swiperight_action']       = buildFunctionQueue($rootScope.settings.views.show.swiperight_action,showfunctions);
			$scope.show['mainswipeup_action']      = buildFunctionQueue($rootScope.settings.views.show.mainswipeup_action,showfunctions);
			$scope.show['mainswipedown_action']    = buildFunctionQueue($rootScope.settings.views.show.mainswipedown_action,showfunctions);
			$scope.show['detailsswipeup_action']   = buildFunctionQueue($rootScope.settings.views.show.detailsswipeup_action,showfunctions);
			$scope.show['detailsswipedown_action'] = buildFunctionQueue($rootScope.settings.views.show.detailsswipedown_action,showfunctions);
			$scope.show['click_action']            = buildFunctionQueue($rootScope.settings.views.show.click_action,showfunctions);
			$scope.show['timeout_action']          = buildFunctionQueue($rootScope.settings.views.show.timeout_action,showfunctions);
			$scope.show['timeouttimems']           = $rootScope.settings.views.show.timeouttimems;
			$scope.show['details_transition']      = $rootScope.settings.views.show.detailstransition;
			$scope.show['oeuvre_transition']       = $rootScope.settings.views.show.transition;

			$scope.show['tpl_heading']             = $rootScope.settings.views.show.tpl_heading || false;

			$scope.show['audio_delay']             = $rootScope.settings.views.show.playdelayms || 0;

			/** Teosnäkymän oletusaudio, jota käytetään jos oeuvre.unique_play_sound:ia ei määritelty */
			$scope.show['default_audio']           = $rootScope.settings.views.show.playsound;

			/** Toiminnot loppunäkymään skippaamiselle */
			if ($rootScope.settings.views.show.hide_skip_to_end) {
				// Ei käytössä -> Ei toimintoja
				$scope.show['skip_to_end_action'] = $scope.nullAction;
			} else {
				$scope.show['skip_to_end_action'] = buildFunctionQueue([ "skip_to_end" ], showfunctions );
			}

			/** Tausta-audio */
			/** @since 7.5.2020 lisätty sekä käytetään uutta asetusmuotoilua */
			try {
				var background_audio = $scope.show.background_audio = {};

				if (opts_show.background_audio) {
					background_audio.filename = opts_show.background_audio;

					if (typeof opts_show["background_audio.enabled"] == "undefined") {
						background_audio.enabled = true;
					} else {
						background_audio.enabled = !!opts_show["background_audio.enabled"];
					}

					if (typeof opts_show["background_audio.repeat"] == "undefined" || !opts_show["background_audio.repeat"]) {
						background_audio.repeat = false;
					} else if (opts_show["background_audio.repeat"] == true) {
						background_audio.repeat = true;
					} else if (!isNaN( parseInt( opts_show["background_audio.repeat"] ))) {
						background_audio.repeat = parseInt( opts_show["background_audio.repeat"]);
					} else {
						console.warn( "Invalid argument :: views.show.backgound_audio.repeat", opts_show["background_audio.repeat"] );
						background_audio.repeat = false;
					}
				}
			} catch( e ) {
				console.error( e );
				$scope.show['background_audio'] = {};
			}


			
			for( var x in $scope.show ){
				if ($scope.show[x] == null) {
					console.warn( "Somehow show['"+ x +"'] = null. Setting to {}." );
					$scope.show[x] = {};
				}
				if ($rootScope.settings.views.show[x+'_icon'] != null) {
					$scope.show[x].icon = $rootScope.settings.views.show[x+'_icon'];
					$scope.show[x].compile = false;
				}
			}

			console.log( "Compiled view.show settigs", $scope.show );
			
			$scope.end = {};
			$scope.end['reached_end_action']    = buildFunctionQueue($rootScope.settings.views.end.reached_end_action,endfunctions);
			$scope.end['cancel_action']         = buildFunctionQueue($rootScope.settings.views.end.cancel_action,endfunctions);
			$scope.end['end_action']            = buildFunctionQueue($rootScope.settings.views.end.end_action,endfunctions);
			$scope.end['generalbutton1_action'] = buildFunctionQueue($rootScope.settings.views.end.generalbutton1_action,endfunctions);
			$scope.end['generalbutton2_action'] = buildFunctionQueue($rootScope.settings.views.end.generalbutton2_action,endfunctions);
			$scope.end['generalbutton3_action'] = buildFunctionQueue($rootScope.settings.views.end.generalbutton3_action,endfunctions);
			$scope.end['generalbutton4_action'] = buildFunctionQueue($rootScope.settings.views.end.generalbutton4_action,endfunctions);
			$scope.end['timeout_action']        = buildFunctionQueue($rootScope.settings.views.end.timeout_action,endfunctions);
			$scope.end['timeouttimems']         = $rootScope.settings.views.end.timeouttimems;
			$scope.end['transition']            = $rootScope.settings.views.end.transition;
			
			for (var x in $scope.end) {
				if ($scope.end[x] == null) {
					console.warn( "Somehow end['"+ x +"'] = null. Setting to {}." );
					$scope.end[x] = {};
				}
				if ($rootScope.settings.views.end[x+'_icon'] != null) {
					$scope.end[x].icon = $rootScope.settings.views.end[x+'_icon'];
				}
			}

			console.log( "Compiled view.end settigs", $scope.end );

			/** @TODO: aseta käyttämään $templateCachea. *_contentit ylikirjoittavat, *_template oletukseksi */
	//		$scope.start_content = $rootScope.settings.views.start.start_content;
			$scope.help_content  = $rootScope.settings.views.help.help_content;

			$scope.end_content             = $rootScope.settings.views.end.end_content;
			$scope.end_content_noselection = $rootScope.settings.views.end.end_content_noselection;
			if (typeof $scope.end_content_noselection == "undefined") {
				console.warn( "No option 'views.end.end_content_noselection' setted: Using 'views.end.end_content'");
				$scope.end_content_noselection = $scope.end_content;
			}

	//		if ($scope.start_content) {
	//			$templateCache.put("templates.start.content.html", $scope.start_content );
	//		}

			$templateCache.put("templates.show.heading.html", $scope.show['tpl_heading'] || '{{ oeuvre.with.client_artist.name }}: {{ oeuvre.with.oeuvre.title }}');


			for (var uid in $scope.oeuvre_list) {
				if ($scope.show['default_audio']) {
					if ($scope.oeuvre_list[uid].audio_sound) {
						$scope.oeuvre_list[uid]['$$audio_sound'] = $scope.oeuvre_list[uid].audio_sound;
					} else if ($scope.oeuvre_list[uid].unique_play_sound) {
						$scope.oeuvre_list[uid]['$$audio_sound'] = $scope.oeuvre_list[uid].unique_play_sound;
					} else {
						$scope.oeuvre_list[uid]['$$audio_sound'] = $scope.show['default_audio'];
					}
				}
			}

			try {
				initializeAnimations();
			} catch (error) {
				console.error( "initializeAnimations() ::", error );
			}

			/*************************************************************************************/

			return $timeout(function() {
			
				$scope.start.initialize_action();

			}).then(function(){

				if ($scope.displayname) try {
					document.title = $scope.displayname + " - " + document.title;
				} catch(e) {}

				$('.oeuvrepanel').on('swipeleft',function(event){
					console.log('swipe left');

					$scope.swipe_action_in_progress = true;

					var tmpcheckelem1 = $('.ng-hide-add');
					var tmpcheckelem2 = $('.ng-hide-remove');
					
						if (tmpcheckelem1.length == 0 && tmpcheckelem2.length == 0) {
						$scope.show.swipeleft_action();
					} else {
						console.log('transition in progress. Event suppressed.');
					}					
				});

				$('.oeuvrepanel').on('swiperight',function(event){
					console.log('swipe right');

					$scope.swipe_action_in_progress = true;

					var tmpcheckelem1 = $('.ng-hide-add');
					var tmpcheckelem2 = $('.ng-hide-remove');
					
					if (tmpcheckelem1.length == 0 && tmpcheckelem2.length == 0) {
						$scope.show.swiperight_action();
					} else {
						console.log('transition in progress. Event suppressed.');
					}		
				});

				$('.oeuvre_main').on('swipeup',function(event){					
					console.log('main swipe up');

					$scope.swipe_action_in_progress = true;
					
					var tmpcheckelem1 = $('.ng-hide-add');
					var tmpcheckelem2 = $('.ng-hide-remove');
					
					if (tmpcheckelem1.length == 0 && tmpcheckelem2.length == 0) {
						$scope.show.mainswipeup_action();
					} else {
						console.log('transition in progress. Event suppressed.');
					}
				});

				$('.oeuvre_main').on('swipedown',function(event){
					console.log('main swipe down');

					$scope.swipe_action_in_progress = true;

					var tmpcheckelem1 = $('.ng-hide-add');
					var tmpcheckelem2 = $('.ng-hide-remove');
					
					if (tmpcheckelem1.length == 0 && tmpcheckelem2.length == 0) {
						$scope.show.mainswipedown_action();
					} else {
						console.log('transition in progress. Event suppressed.');
					}
				});

				$('.oeuvre_details').on('swipeup',function(event){
					console.log('details swipe up');

					$scope.swipe_action_in_progress = true;

					var tmpcheckelem1 = $('.ng-hide-add');
					var tmpcheckelem2 = $('.ng-hide-remove');
					
					if (tmpcheckelem1.length == 0 && tmpcheckelem2.length == 0) {
						$scope.show.detailsswipeup_action();
					} else {
						console.log('transition in progress. Event suppressed.');
					}
				});

				$('.oeuvre_details').on('swipedown',function(event){
					console.log('details swipe down');

					$scope.swipe_action_in_progress = true;

					if ($(this).scrollTop() < 50) {
						var tmpcheckelem1 = $('.ng-hide-add');
						var tmpcheckelem2 = $('.ng-hide-remove');
						
						if (tmpcheckelem1.length == 0 && tmpcheckelem2.length == 0) {
							$scope.show.detailsswipedown_action();
						} else{
							console.log('transition in progress. Event suppressed.');
						}
					} else {
						console.log('details not at top. ignoring swipe down');
					}
				});

				//$scope.swipe_action_in_progress = true;
				$('#zoomcanvascontainer').dragScroll({});
				$('#controlscontainer #position_indicator').dragScroll({});
				//console.log($('.oeuvrepanel .oeuvre_image .image_container img'));
	//				$('.oeuvrepanel .oeuvre_image .image_container').on('click', function(){ $scope.onOeuvreImageClick(); });
				$scope.onOeuvreImageClick = function( event ){
					
					if(!$scope.swipe_action_in_progress){
						
						var tmpcheckelem1 = $('.ng-hide-add');
						var tmpcheckelem2 = $('.ng-hide-remove');
						
						if(tmpcheckelem1.length == 0 && tmpcheckelem2.length == 0){
							console.log('image click');
							$scope.show.click_action();
						}
						else{
							console.log('transition in progress. Click event suppressed.');
						}
						
					}
					else{
						$scope.swipe_action_in_progress = false;
					}
					
				}
			});
		})
		.catch(function(err){
			console.error( 'Apihandler could not load oeuvre list', err );
		});

		/*************************************************************************************/

		$scope.$watch( "currentstate", function( state, from ){
			console.debug( "currentstate changed", from, "->", state );

			$scope.current_slide.state = state;

			if ("show_" == state.substr( 0, 5 )) {
				var item_uid = state.substr( 5 );

				$scope.current_slide.item_uid  = item_uid;
				$scope.current_slide.isettings = $scope.settings.oeuvre_settings[ item_uid ];

				$scope.current_slide.isettings.$showCount = ($scope.current_slide.isettings.$showCount || 0) + 1;

			} else {
				$scope.current_slide.isettings = { };
				$scope.current_slide.oeuvre    = null;

				switch (state) {
					case "initial": 
					case "start": 
					case "end": 
						break;
				}
			}

			$refreshCurrentAudio();
		});


		$scope.oeuvre_index = 0;
		$scope.show_details = false;
		$scope.show_zoom    = false;
		$scope.nullAction   = function(){};

		Object.defineProperty( $scope, "current_slide", { value: {} });

		// Purkkaa, purkkaa, ei, ei
		function $refreshCurrentAudio() {
			console.debug( "$refreshCurrentAudio()" );

			try {
				if ($scope.currentstate.substr( 0, 5 ) == "show_") {
					$scope.current_slide.audioElem = document.querySelector( " #oeuvre_container_" + $scope.currentstate.substr( 5 ) + " .oeuvre_sound > audio" ) || null;
				} else {
					$scope.current_slide.audioElem = null;
				}
			} catch( err ){
				console.error( "$refreshCurrentAudio() ::", err );
			}
		}



		function buildFunctionQueue( acts, lib ) {

			// Normalisoidaan toiminnot taulukoksi
			acts = acts || [];
			if (!Array.isArray(acts)) acts = [ acts ];

			if (acts.length == 0) {
				var retfunc = $scope.nullAction;
				//retfunc['icon'] == "";
				return retfunc;
			}

			// Muotoillaan asetuksissa määritellyt toiminnot objektipohjaisiksi
			acts = acts.map(function( ac ){
				var item = { "fn": "","params":"" };

				if (typeof ac == "string") {
					item.fn     = ac;
					item.params = {};
				} else {
					if (ac.fn != null) {
						item.fn = ac.fn;
					}

					item.params = ac.params || {};
				}
				return item;
			});
			
			var retfunc = function(){
				acts.forEach(function( act ){	
					try {
						if (lib[act.fn] instanceof Function) {
							lib[act.fn](act.params);
						} else {
							console.log('unrecognized function');
						}
					} catch( error ) {
						console.error( "Error while compiling action", act, error );
					}
				})
			}

			var tmpicon = { "icon": "", "priority": 0 };
			acts.forEach(function( act ){

				//decide default icon according to function:
				if (lib.icons[act.fn] != null) {
					if (tmpicon.priority < lib.icons[act.fn].priority) {
						tmpicon.icon = lib.icons[act.fn].icon;
						tmpicon.priority = lib.icons[act.fn].priority;
						tmpicon.compile = !!lib.icons[act.fn].compile;
					}
				}
			})
		
			retfunc.acts = acts;
			
			retfunc.canBeRun = function(){
				var can = false;
				for (var i in acts) {
					if (can = can || findCanBeRun( acts[i] )) break;
				}
				return can; 

				function findCanBeRun( act ) {
					if (lib == startfunctions) {
						return true;
					}

					if (lib == endfunctions) {
						switch(act.fn){
							case "gotopreview":
								if($scope.selected != null && $scope.selected.length > 0){
									return true;
								}
								return false;
							case "restart":
								if (acts.length == 1) return true;
								else return false;
							case "clearselected": 
								return !!($scope.selected && Object.keys( $scope.selected ).length > 0);
							default: return true;
						}
						
					}

					if (lib == showfunctions) {
						switch( act.fn ){
							case "default": return false;
							case "showprevious": 
								if ($scope.oeuvre_index == 0) return false;
								return true;
							case "shownext": return true;
							case "showdetails" : 
								if ($scope.oeuvre_list[$scope.oeuvre_index] == null)       return false;
								if ($scope.oeuvre_list[$scope.oeuvre_index].show_details)  return false;
								return true;
							case "showmain" : 
								if ($scope.oeuvre_list[$scope.oeuvre_index] == null)       return false;
								if (!$scope.oeuvre_list[$scope.oeuvre_index].show_details) return false;
								return true;
							case "select" :
								if ($scope.oeuvre_list[$scope.oeuvre_index] == null) return false;
								if ($scope.oeuvre_list[$scope.oeuvre_index].show_details) {
									return false;
								} else {
									if (act.params != null && act.params.allowdeselect != null && act.params.allowdeselect) {
										return true;
									} else {
										if ($scope.selected != null) {
											if ($scope.selected.includes($scope.oeuvre_list[$scope.oeuvre_index])) {
												return false;
											}
										}
									}
								}
								return true;
							default:
								return true;
						}
						return true;
					} else {
						return false;
					}
				}
			}
			
			if (tmpicon.compile) {
				try {
					retfunc.icon = $interpolate( tmpicon.icon )( $scope );
				} catch(e){
					console.error( "Failed to $compile() icon", icon, e );
				}
			}
			retfunc.icon = retfunc.icon || tmpicon.icon;
			
			return retfunc;	
		};


		/**************************/

		var default_icon = {
			"priority" : "0",
			"icon"     : ""
		};

		angular.extend( globalfunctions, {
			"audio.toggle_mute": function() {
				$rootScope.toggleAudioMute();
			},
			"background_audio.stop": function() {
				var player = document.getElementById( "background-audio-player" );
				if (player) {
					player.pause();
					player.src = player.src;
					player.currentTime = 0;
				}
			},
			"showstart": function(){
				showStart();
				return timeoutaction();
			},
			"location_href": function( options ) {
				if (options.href) location.href = options.href;
			},
			"showUniversalCurrent": function( args ) {

				args = args || [];

				var showcase_universal_start_time = args[0] && new Date( args[0] );
				
				var showcase_duration_ms = args[1] && parseInt( args[0] );

				var __ignore_recheck = args[2];
				
				/**********
				 *
				 */
				if (showcase_universal_start_time == null || isNaN( showcase_universal_start_time )) {
					if ($scope.showcase_universal_start_time) {
						showcase_universal_start_time = $scope.showcase_universal_start_time;
					}
				}

				if (showcase_universal_start_time == null || isNaN( showcase_universal_start_time )) return;

				/**********
				 * 
				 */
				if (showcase_duration_ms == null) {
					showcase_duration_ms = slides.reduce(function( showcase_duration_ms, slide ) {

						var duration_ms = slide.$settings.timeouttimems || null;

						return showcase_duration_ms + (duration_ms || 0);

					}, 0);
				}
				
				if (showcase_duration_ms == null || isNaN( showcase_duration_ms )) return;

				/***********/
						
				$scope.showcase_universal_start_time = showcase_universal_start_time;
			
				window.solveUniversalCurrentSlideState = solveUniversalCurrentSlideState.bind( null, showcase_universal_start_time, showcase_duration_ms );
				
				var state = solveUniversalCurrentSlideState( showcase_universal_start_time, showcase_duration_ms );

				if (state == null) return;

				movetoview( state.current_slide_idx, false, true );

				if (state.unsure && !__ignore_recheck) {

					window.DEV && Notification.warning( "globalfunctions.showUniversalCurrent() :: unsure so rechecking in 100ms!!" );

					setTimeout(function() {

						globalfunctions.showUniversalCurrent([ null, null, true ]);

					}, 100 );
				}
			}
		});

		function solveUniversalCurrentSlideState( showcase_universal_start_time, showcase_duration_ms ) {

			var unsure = false;

			// Mikä on nykyinen ajanhetki loopissa
			var showcase_current_time_ms = (Date.now() - showcase_universal_start_time) % showcase_duration_ms;

			for (var current_slide_idx = 0; current_slide_idx < slides.length; current_slide_idx++) {

				var duration_ms = slides[ current_slide_idx ].$settings.timeouttimems;

				if (duration_ms) {

					// Tarkastellaanko nykyistä diaa? (Nykyisen dian kesto on jäljellä olevaa aikaa vähemmän)
					if (showcase_current_time_ms < duration_ms) {

						// Ollaanko liian lopussa nykyisessä diassa?
						if (duration_ms - showcase_current_time_ms < 1000) {
							// Jos, niin ohjataan varmuuden vuoksi seuraavaan diaan
						
							current_slide_idx = current_slide_idx + 1;

							if (current_slide_idx == slides.length) {
								current_slide_idx = 0;

								// Viimeisestä diasta ensimmäiseen siirtyessä on vaaranpaikka, joten viestitetään eteenpäin, että annetut tiedot mahdollisesti eroavat todellisista
								unsure = true;
							}

							showcase_current_time_ms = 0;
						}

						return { current_slide_idx: current_slide_idx, current_time_ms: showcase_current_time_ms, unsure: unsure };
					}

					showcase_current_time_ms -= duration_ms
				}
			}
		}

		globalfunctions.icons = {
			"showstart": {
				"priority": 1,
				"icon": "<span class='glyphicon glyphicon-log-out showstart-btn'></span>"
			},
			"location_href": {
				"priority": 1,
				"icon": "<span class='glyphicon glyphicon-log-out showstart-btn'></span>"
			},
			'showUniversalCurrent': angular.copy( default_icon )
		};

		angular.extend( startfunctions, globalfunctions );
		angular.extend(  showfunctions, globalfunctions );
		angular.extend(   endfunctions, globalfunctions );

		/**************************/

		startfunctions['icons'] = angular.extend({ }, startfunctions['icons'] );
		
		startfunctions['initclearstart'] = function(args){
			console.log('initialize all recorded variables');
			$scope.stored_variables = {};
			if($scope.selected != null){
				$scope.selected =[];
			}
		};

		startfunctions.icons['initclearstart'] = angular.copy( default_icon );

		startfunctions['initstart'] = function(args){
			console.log('initialize start');
			$scope.oeuvre_index = 0;
			$scope.showinquire = false;
			$scope.showselected = false;
			timeoutaction();
		};

		startfunctions.icons['initstart'] = angular.copy( default_icon );

		startfunctions['shownext'] = function(args){
			showNext();
			timeoutaction();
		};

		startfunctions.icons['shownext'] = angular.copy( default_icon );

		startfunctions['cancel'] = function(args){
			console.log('cancel clicked');
			timeoutaction();
		};

		startfunctions.icons['cancel'] = angular.copy( default_icon );

		startfunctions['default'] = function( args ) {
			console.debug("startfunctions['default']", args );

			try {
				if ($scope.show.background_audio && $scope.show.background_audio.enabled) {
					var background_audio = $scope.show.background_audio;
					var elem = document.getElementById( "background-audio-player" );

					if (typeof background_audio.repeat == "number") {
						var iterator = background_audio.repeat;
						elem.onended = function() { if (--iterator > 0) elem.play(); };
					} else if (background_audio.repeat == true) {
						elem.loop = true;
					}

					setTimeout(function(){
						elem.play();
					});
				}
			} catch(e) {
				console.error(e);
				$scope.show.background_audio.enabled = false;
			}

			console.log('take no action');
			timeoutaction();
		};

		startfunctions.icons['default'] = angular.copy( default_icon );

		/**************************/

		showfunctions['icons'] = angular.extend({ }, showfunctions['icons'] );

		showfunctions['showUniversalCurrent'] = startfunctions['showUniversalCurrent']

		showfunctions['shownext'] = function(args){
			showNext();
			timeoutaction();
		};
		showfunctions.icons['shownext'] = {
			"priority" :1,
			"icon": "<span class='glyphicon glyphicon-chevron-right'></span>"
		};

		showfunctions['showprevious'] = function(args){
			showPrevious();
			timeoutaction();
		};
		showfunctions.icons['showprevious'] = {
			"priority" :1,
			"icon": "<span class='glyphicon glyphicon-chevron-left'></span>"
		};

		showfunctions['skip_to_end'] = function( args ){
			handleOeuvreNextTransition( '#oeuvre_container_'+$scope.oeuvre_list[$scope.oeuvre_index].uid, null );
			$scope.oeuvre_index = $scope.oeuvre_list.length - 1;
			showNext();
			timeoutaction();
		};
		showfunctions.icons['skip_to_end'] = {
			priority: 1,
			icon:    "<span class='d-none d-sm-inline-block'>{{ 'Skip to end' | translate }}</span>",
			compile: true
		};

		showfunctions['select'] = function(args){
			console.log('select');
			if(args.animate == null){
				args['animate'] = false;
			}
			if(args.animation_time_ms == null){
				args['animation_time_ms'] = false;
			}
			if(args.allowdeselect == null){
				args['allowdeselect'] = false;
			}
			if($scope.selected == null){
				$scope['selected'] = new Array();
			}
			var tmpcheck = $('#oeuvre_container_'+$scope.oeuvre_list[$scope.oeuvre_index].uid+' .oeuvre_main');
			if(tmpcheck.length != 1){
				console.log('select in process, ignoring');
				return;
			}
			if ($scope.selected.indexOf($scope.oeuvre_list[$scope.oeuvre_index]) != -1) {
				if(args.allowdeselect){
					var delind = $scope.selected.indexOf($scope.oeuvre_list[$scope.oeuvre_index]);
					$scope.selected.splice(delind,1);
					console.log('deselected');
					
					if(args.animate && args.animation_time_ms){
						console.log('play animation');
						var tmpnode = $('#oeuvre_container_'+$scope.oeuvre_list[$scope.oeuvre_index].uid+' .oeuvre_main').clone(false);
						tmpnode.addClass(args.animate+'_reverse');
						
						$('#oeuvre_container_'+$scope.oeuvre_list[$scope.oeuvre_index].uid).append(tmpnode);
						$timeout(function(){
							$scope.swipe_action_in_progress = false;
							tmpnode.remove();
						},args.animation_time_ms);
					}
					return;
				}
				else{
					console.log('already selected');
					return;
				}
				
			}
			$scope.selected.push($scope.oeuvre_list[$scope.oeuvre_index]);
			if(args.animate && args.animation_time_ms){
				console.log('play animation');
				var tmpnode = $('#oeuvre_container_'+$scope.oeuvre_list[$scope.oeuvre_index].uid+' .oeuvre_main').clone(false);
				tmpnode.addClass(args.animate);
				
				$('#oeuvre_container_'+$scope.oeuvre_list[$scope.oeuvre_index].uid).append(tmpnode);
				$timeout(function(){
					$scope.swipe_action_in_progress = false;
					tmpnode.remove();
				},args.animation_time_ms);
			}
			
			
			return $timeout(function(){});
		};
		showfunctions.icons['select'] = {
			"priority" :1,
	//		"icon": gettextCatalog.getString( "Click to choose" )
			"icon": "{{ 'Click to choose'|translate }}",
			"compile": true
		};

		showfunctions['showdetails'] = function(args){
			$scope.oeuvre_list[$scope.oeuvre_index].show_details = true;
			//$scope.show_details = true;
	//			$timeout(timeoutaction);
		};
		showfunctions.icons['showdetails'] = {
			"priority" : 1,
	//		"icon": gettextCatalog.getString( "Click to show details" ),
			"icon": "{{ 'Click to show details'|translate }}",
			"compile": true
		};

		showfunctions['showmain'] = function(){
			$scope.oeuvre_list[$scope.oeuvre_index].show_details = false;
			$scope.oeuvre_list[$scope.oeuvre_index].$settings.$showCount = ($scope.oeuvre_list[$scope.oeuvre_index].$settings.$showCount || 0) + 1;
			//$scope.show_details = false;
	//			$scope.$apply();
	//			timeoutaction();
		};
		showfunctions.icons['showmain'] = {
			"priority" : 1,
	//		"icon" : gettextCatalog.getString( "Click to go back" )
			"icon" : "{{ 'Click to return back'|translate }}",
			"compile": true
		};

		showfunctions['zoom'] = $scope.open_zoom;

		showfunctions.icons['zoom'] = angular.extend({}, default_icon, { "priority": 1 });
		
		/*************************/

		showfunctions['wallpreview'] = function(args){

			if (wallpreview.$opening) return console.warn('PreviewApp_open() :: wallpreview already opening, ignoring simultaneous open');
			console.log('PreviewApp_open() :: ', args);

			wallpreview.$opening = true;

			$scope.wallpreview.walls             = $scope.wallpreview.walls || [];
			$scope.wallpreview.show_wall_select  = false;
			$scope.wallpreview.show_wall         = false;
			$scope.wallpreview.project_uid       = args.project_uid;
			$scope.wallpreview.client_oeuvre_uid = $scope.oeuvre_list[$scope.oeuvre_index].uid;
			$scope.wallpreview.oeuvre            = $scope.oeuvre_list[$scope.oeuvre_index];


			
			if ($scope.wallpreview.project == null) {
				$ApiHandler.get("/arrangement_projects/"+ $scope.wallpreview.project_uid, {
					'filters': "asarray,onlydata,onlyattrs"
				}).then(function( response ){
					$scope.wallpreview.project = response.data[0];

					for (var x in $scope.wallpreview.project.with.walls) try {

						var wall = $scope.wallpreview.project.with.walls[x];
						wall.img_src = "/i/"+ wall.image_uid +"?size=normal"

						if (typeof wall.data == "string") wall.data = JSON.parse( wall.data );

						var planes = Object.keys(wall.data.planes).map(function(hash){ return wall.data.planes[ hash ]; });
						
						if (planes.length == 0) {
							console.error( "No planes on the wall!");
						} else {
							planes = planes.filter(function( plane ){ return plane.style == 3; });

							if (planes.length == 0) {
								console.error("No acceptable planes (plumb squares) on the wall!");
							} else {
								$scope.wallpreview.walls.push( wall );
							}
						}
					} catch (error) {
						console.error( error );
					}

					$scope.wallpreview.open();
				});
			} else {
				$scope.wallpreview.open();
			}	
		}
		
		showfunctions.icons['wallpreview'] = angular.extend({}, default_icon, { "priority": 1 });
		
		showfunctions['default'] = function(args){
			console.log('default action');
			console.log('take no action');
			timeoutaction();
		}

	/**********/

		
		endfunctions = angular.extend( {}, endfunctions, {
			default: function(args){
				console.log('default end action');
				timeoutaction();
			},
			restart: function(args){
				setCurrentState( 'start' );
				$scope.show_details = false;
				$scope.oeuvre_index = 0;
				$scope.start.initialize_action();

				return $timeout(function(){});
			},
			finalize: function(args){
				console.log('end reached, finalizing action');
				timeoutaction();
			},
			showselected: function(args){
				console.log('show selected');
				if($scope.showselected == null){
					$scope['showselected'] = false;
				}
				$scope.showselected = true;
				$scope.selectedtodisplay = $scope.selected;
				timeoutaction();
			},
			showinquire: function(args){
				
				$.getScript('/libs/cms/controllers/modal.inquire-oeuvre.js')
				.done(function(response, textStatus){
					$timeout(function() {
						var js = response;
						var new_js = 'new Array("$scope","$ApiHandler","$templateRequest","$timeout", function(  $scope,  $ApiHandler,  $templateRequest,  $timeout )'+ js.substr( js.indexOf("{"));

						var $modalOpts_oeuvres = [];
						for (var i in $scope.selected) try {
							var json = {};

							try {
								for (var k in $scope.selected[i]) if (k[0] != "$") json[k] = $scope.selected[i][k];
								json = JSON.stringify( json );
							} catch(err) { console.error(err); }

							if (typeof json == "string") $modalOpts_oeuvres.push( JSON.parse( json ));
						} catch( err ) { console.warn( err ); }

						var outer_js = '(function(){'
							+ 'var $uibModalInstance = {};'
							+ 'var $modalOpts = { "client_uid":"' + $rootScope.client_uid + '", "oeuvres": ' + JSON.stringify( $modalOpts_oeuvres ) + ', onSubmitSuccess:function(){ angular.element("body").injector().get("Notification").success("Viesti lähetetty!"); } };'
							+ 'var $User = {};'
							+ 'return '+ new_js + ';'
						+ '})()';

						var ret = eval(outer_js);
						
						$scope.inquireControllerFn = ret;
						window.controllerProvider.register($scope.inquireControllerName,ret);
						$scope.showinquire = true;
					}).catch(function( err ){
						console.error( "endfunctions.showinquire:", err );
					});
				});
			},
			gotopreview: function(args){
				var gotourl = args.previewurl;
				if (!gotourl) {
					gotourl = window.artestRootDomain+"/preview/#!/fast-preview?ub_return_to="+ encodeURIComponent(location.host + location.pathname) +"&";
				}
				
				console.log('go to preview');
				if ($scope.selected == null) {
					return console.log('nothing to preview. aborting');
				}

				gotourl += "pouid=" + $scope.selected.map(function(v){ return v.uid; }).join( "," );

				window.open(gotourl);
				timeoutaction();
			},
			clearselected: function(args){
				console.log('clear selected');
				if($scope.selected != null){
					$scope.selected = [];
				}
				timeoutaction();
			},
			close: function(args){
				window.close();
			}
		});


		endfunctions['icons'] = angular.extend({ }, endfunctions['icons'], {
			'restart': {
				"priority" : 1,
		//		"icon" : gettextCatalog.getString( "Click to start again" )
				"icon" : "{{ 'Click to start again'|translate }}",
				"compile": true
			},
			'gotopreview': {
				"priority": 1,
		//		"icon" : gettextCatalog.getString( "Go to preview" )
				"icon" : "{{ 'Go to preview'|translate }}",
				"compile": true
			},
			'clearselected': {
				"priority" : 2,
				"icon" : "{{ 'Click to empty list'|translate }}",
				"compile": true
			},
		});

		/*******************************/

		$scope.checkifselected = function( oeuvreuid ) {
			if (!!oeuvreuid) {
				for (var i in $scope.selected) {
					if ($scope.selected[i].uid == oeuvreuid) return true;
				}
			}

			return false;
		};

		$scope.movetoview = movetoview;
		
		function movetoview( ind, noFocus, force ) {
			console.log( 'move to view' );
	//		$scope.currentoeuvre = null;

			if (!force && $('div.viewpanel.ng-hide-add').length != 0) return console.log('Transition in progress. aborting.');

			if (!force && $('div.viewpanel.ng-hide-remove').length != 0) return console.log('Transition in progress. aborting.');

			if ($scope.currentstate == "start") {
				if ($scope.start.start_action && $scope.start.start_action.acts) {
					$scope.start.start_action.acts.forEach(function( act ){
						switch (act.fn) {
							case "default": startfunctions['default']();
						}
					});
				}

				$scope.oeuvre_index = ind;
				$scope.oeuvre_list[$scope.oeuvre_index].show_details = false;
				setCurrentState( 'show_'+$scope.oeuvre_list[$scope.oeuvre_index].uid );
				$scope.currentoeuvre = $scope.oeuvre_list[$scope.oeuvre_index].uid;
				handleOeuvreNextTransition(
					null,
					'#oeuvre_container_'+$scope.oeuvre_list[$scope.oeuvre_index].uid,
					noFocus
				);
			} else if ($scope.currentstate == "end") {
				$scope.oeuvre_index = ind;
				$scope.oeuvre_list[$scope.oeuvre_index].show_details = false;
				setCurrentState( 'show_'+$scope.oeuvre_list[$scope.oeuvre_index].uid );
				$scope.currentoeuvre = $scope.oeuvre_list[$scope.oeuvre_index].uid;
				handleOeuvrePreviousTransition(
					'#endcontainer',
					'#oeuvre_container_'+$scope.oeuvre_list[$scope.oeuvre_index].uid,
					noFocus
				);
			} else 

			if ($scope.currentstate != 'initial' && $scope.currentstate != 'end' && $scope.currentstate != 'start') {
	/*			var tmpcheckelem1 = $('.ng-hide-add');
				var tmpcheckelem2 = $('.ng-hide-remove');
							
				if (tmpcheckelem1.length == 0 && tmpcheckelem2.length == 0) {*/
					$scope.oeuvre_list[$scope.oeuvre_index].show_details = false;

					if ($scope.oeuvre_index < ind) {
						handleOeuvreNextTransition(
							'#oeuvre_container_'+$scope.oeuvre_list[$scope.oeuvre_index].uid,
							'#oeuvre_container_'+$scope.oeuvre_list[ind].uid,
							noFocus
						);
					} else if ($scope.oeuvre_index > ind) {
						handleOeuvrePreviousTransition(
							'#oeuvre_container_'+$scope.oeuvre_list[$scope.oeuvre_index].uid,
							'#oeuvre_container_'+$scope.oeuvre_list[ind].uid,
							noFocus
						);
					} else {
						//same oeuvre selected. do nothing
					}
					
					$scope.oeuvre_index = ind;
					setCurrentState( 'show_'+$scope.oeuvre_list[$scope.oeuvre_index].uid );
					$scope.currentoeuvre = $scope.oeuvre_list[$scope.oeuvre_index].uid;
	/*			} else {
					console.log('Transition in progress. aborting.');
				}*/
			}

			timeoutaction();
		};

		/***************************************/

		var backgroundLoopFn_counter = 0;
		function backgroundLoopFn( ignoreTriggers ) {

			backgroundLoopFn_counter++;

			var jobs = [];

			if ($scope.current_slide && $scope.current_slide.audioElem) {
				
				if ($scope.current_slide.isettings && $scope.current_slide.isettings.$$get_ms_in_global_loop) {
					jobs.push( refreshCustomConfigs_itemUSLST( $scope.current_slide.item_uid ));
				}

	//			if (backgroundLoopFn_counter % 5 == 3) {
	//				$scope.current_slide.audioElem.$$synchrotron_fn();
	//			}
			}

			jobs.push( showcaseEngineModifier.run( "showcaseController_backgroundLoopFn()", { }));

			if (jobs.length == 0) return;

			//console.count("backgroundLoopFn()");

			return $q.all( jobs );

			/*********/

			function refreshCustomConfigs_itemUSLST( item ) {

				var isettings = $scope.current_slide.isettings;

				return isettings.$$fetch_universal_slide_loop_start_time().then(function( updated ){
					if (updated) {
						if (!ignoreTriggers) {
							timeoutaction();
							$scope.current_slide.audioElem.$$synchrotron_fn()
						}
					}
				});
			}
		}

		/***************************************
		 * Alustetaan nykyisen dian kulumiseen liittyvä ajastus, dian kulumisen seuranta, visuaaliset elementit (kello ja #runningtimeout-indicator),
		 * sekä toiminnot ajettavaksi ajastuksen päättyessä
		 */
		window.timeoutaction = $scope.timeoutaction = timeoutaction;
		function timeoutaction() {
			console.debug( "timeoutaction()" );

			$rootScope.runningtimeout = $rootScope.runningtimeout && $rootScope.runningtimeout.stop() || null;

			var _timeout_fn, _timeout_ms, _timeout_opts = { watcher_freq_ms: 250 /** Huom! CSS:ssa asetetaan transition: width: 250ms; */ };
			var _timeout_ms_offset = 0;

			var timeout_indicator_elem    = document.getElementById( "runningtimeout-indicator" );

			if (timeout_indicator_elem) {
				timeout_indicator_elem.style.width = "0%";

				_timeout_opts.watcher_fn = (function() {
					var _prev_curr_s, _prev_curr_ms, timeout_time_counter_elem;

					return function TimeoutIndicatorUpdater() {
						try {
							timeout_indicator_elem.style.width = ( 100 * Math.min( 1, this.play_ms / this.timeout_ms )).toFixed( 2 ) + "%";
						} catch(e) {}

						try {
							if (!timeout_time_counter_elem) timeout_time_counter_elem = document.getElementById( "animation-time-counter" );
							if (timeout_time_counter_elem) {
								var curr_ms = this.play_ms + this.opts.offset_ms;
								var curr_s  = parseInt( curr_ms / 1000 );

								var shouldUpdate = _prev_curr_s != curr_s;

								/** DEV **/
								if ($rootScope.DEV && !shouldUpdate && curr_ms - _prev_curr_ms > 500) {
									_prev_curr_ms = curr_ms;
									shouldUpdate = true;
								}
								/** /DEV **/

								if (shouldUpdate) {
									_prev_curr_s  = curr_s;
									_prev_curr_ms = curr_ms;

									var curr = [ parseInt( curr_s / 60 ), curr_s % 60 ];
									if (curr[1] < 10) curr[1] = "0" +  curr[1];

									var total_ms = this.timeout_ms + this.opts.offset_ms;
									var total = [ parseInt( total_ms / 1000 / 60 ), parseInt( total_ms / 1000 ) % 60 ];
									if (total[1] < 10) total[1] = "0" + total[1];

									var str = curr.join( ":" ) + "/" + total.join( ":" );

									// Siivotaan ajastin pois, jottei näy epäloogista aikaa
									if (curr_ms > total_ms && !$rootScope.DEV) {
										str = "";
									}

									/** DEV **/
									/*if ($rootScope.DEV) try {
										str = curr.join( ":" ) + "(" + curr_ms

										if ($scope.current_slide.isettings && $scope.current_slide.isettings.$$get_ms_in_global_loop) {
											str += "(abs.diff:" + Math.abs($scope.current_slide.isettings.$$get_ms_in_global_loop() - curr_ms) + "ms)";
										}

										str += ")/" + total.join( ":" );

										if ($scope.current_slide.audioElem) {
											var __cTime = parseInt( $scope.current_slide.audioElem.currentTime * 1000 );
											var __diff = parseInt( __cTime - curr_ms );
											str += " (cT:" + __cTime + ", Diff" + (__diff>=0?"+":"") + __diff + "ms)";

											if ($scope.current_slide.item_uid && $scope.current_slide.isettings.$$get_ms_in_global_loop) {
												$(".oeuvre_image > .image_container").html("");
												var elem = $("#oeuvre_container_" + $scope.current_slide.item_uid + " .oeuvre_image > .image_container"), html = [];

												html.push([ 1, " $$get_ms_in_global_loop(): ", $scope.current_slide.isettings.$$get_ms_in_global_loop() ]);
												html.push([ 2, " $$get_ms_from_global_start_time(): ", $scope.current_slide.isettings.$$get_ms_from_global_start_time() ]);

												html.push( "" );

												html.push([ 3, " audioElem.currentTime: ", $scope.current_slide.audioElem.currentTime ]);
												html.push([ 4, " audioElem.$$getCurrentTime(): ", $scope.current_slide.audioElem.$$getCurrentTime() ]);

												html.push( "" );

												html.push([ 5, " TimeoutRunner.timeout_ms: ", (this.timeout_ms||0) ]);
												html.push([ 6, " TimeoutRunner.opts.offset_ms: ", (this.opts.offset_ms||0) ]);
												html.push([ 7, " TimeoutRunner.play_ms: ", this.play_ms ]);
												html.push([ 8, " TimeoutRunner :: curr_ms: ", curr_ms ]);
												html.push([ 9, " TimeoutRunner :: total_ms: ", (this.timeout_ms||0)+(this.offset_ms||0) ]);
												
												html.push( "" );
												html.push([ "Audio: 4-3: ", $scope.current_slide.audioElem.$$getCurrentTime()-$scope.current_slide.audioElem.currentTime ]);
												html.push( "" );
												html.push([ "Timeout: 8-3: ", (curr_ms/1000) - $scope.current_slide.audioElem.currentTime ]);
												html.push( "" );



												elem.css({
													"text-align": "left",
													"text-shadow": "0px 0px 3px #fff",
													"font-size": "0.9em",
													"font-weight": "bold"
												}).html( html.map(function( row ){
													return Array.isArray(row) ? row.join("") : row;
												}).join("<br>") );
											}
										}
									} catch(e) { console.error(e); }
									/** /DEV **/

									timeout_time_counter_elem.firstElementChild.textContent = str;
								}
							}
						} catch(e) {}
					};
				})();
			}

		
			if ($scope.currentstate == 'initial') {
				// Aloitusnäkymässä ei tarvetta ajastimille
			} else if ($scope.currentstate == 'start') {
				_timeout_ms = $scope.start.timeouttimems;
				_timeout_fn = function(){
					if ($scope.show_help || $scope.show_zoom) {
						console.log('help or zoom open, ignoring timeout action');
					} else {
						$scope.start.timeout_action();
					}
				};
			} else if ($scope.currentstate == 'end') {
				_timeout_ms = $scope.end.timeouttimems;
				_timeout_fn = function(){
					if ($scope.show_help || $scope.show_zoom || $scope.show_wall_preview) {
						console.log('help or zoom open, ignoring timeout action');
					} else {
						$scope.end.timeout_action();
					}
				};
			} else if ($scope.currentstate.substr( 0, 5 ) == "show_") {
				_timeout_ms = $scope.show.timeouttimems;

				var isettings = $scope.currentoeuvre && $scope.settings.oeuvre_settings[ $scope.currentoeuvre ];
				if (isettings) {
					isettings.$$timeout_offset_ms = 0;

					if (isettings.timeouttimems) {
						_timeout_ms = isettings.timeouttimems;
					}

					var slide_start_time = isettings.$$universal_slide_loop_start_time;

					if (_timeout_ms && slide_start_time != null) {
					//if (_timeout_ms && isettings.$$universal_slide_loop_start_time) {
						var slide_time = Date.now();
						var srvr_aikaa_epochista = window.SERVER_LOAD_TIME - slide_start_time;
						//var srvr_aikaa_epochista = window.SERVER_LOAD_TIME - isettings.$$universal_slide_loop_start_time;
						var brws_aikaa_sivunlatauksesta = slide_time - window.BROWSER_LOAD_TIME;
						var abt_aikaa_epochista = srvr_aikaa_epochista + brws_aikaa_sivunlatauksesta;

						_timeout_ms_offset = isettings.$$timeout_offset_ms = abt_aikaa_epochista % _timeout_ms;

						if (false && window.DEV)  {
							var asd = [
								["The Alkuaika palvelimen mukaan",        new Date( parseInt( isettings.$$universal_slide_loop_start_time )).toString()],
								["Sivunlatauksen aika palvelimen mukaan", new Date( window.SERVER_LOAD_TIME ).toString()],
								["Sivunlatauksen alka selaimen mukaan",   new Date( window.BROWSER_LOAD_TIME ).toString()],
								["Siirtymisaika slideen selaimen mukaan", new Date( slide_time ).toString()],
								["Selaimen ja palvelimen aikaero millisekunneissa", window.BROWSER_LOAD_TIME  - window.SERVER_LOAD_TIME ],
								["Millisekunteja The Alkuajasta palvelimen mukaan", window.SERVER_LOAD_TIME - parseInt(isettings.$$universal_slide_loop_start_time) ],
								["Millisekunteja The Alkuajasta selaimen mukaan",   window.SERVER_LOAD_TIME - parseInt(isettings.$$universal_slide_loop_start_time) + (window.BROWSER_LOAD_TIME  - window.SERVER_LOAD_TIME) ],
								["Millisekunteja sivunlatauksesta slideen siirtmiseen selaimen mukaan", brws_aikaa_sivunlatauksesta ],
								["Millisekunteja The Alkuajasta slideen siirtymiseen selaimen mukaan",  abt_aikaa_epochista ],
								["_timeout_ms =", _timeout_ms ],
								["Looppeja The Alkuajasta slideen siirtymiseen", parseInt(abt_aikaa_epochista / _timeout_ms) ],
								["Millisekunteja nykyistä looppia mennyt", _timeout_ms_offset ],
								["Lopullinen _timeout_ms =", _timeout_ms - _timeout_ms_offset ]
							];
							console.table( asd );
						}

						// Jäljellä olevaksi aika on kokonaisaika vähennettynä jo kuluneeksi tulkitulla ajalla
						_timeout_ms = _timeout_ms - _timeout_ms_offset
					}
				}

				_timeout_fn = function(){

					/** Jos sallitaan shown jatkuminen, vaikka erikoistila on päällä, jatketaan showta */

					if ($scope.show_help && !$scope.settings.views.help.show_must_go_on) {
						console.log( 'Should run timeout action, but help open' );

						if ($scope.settings.views.help.timeout_extend) {
							var extend_timeout_action_deregistration = $scope.$on( "help.close", function(){
								extend_timeout_action_deregistration();
								$scope.show.timeout_action();
							});

							return console.log( 'timeout_extend wanted. Initiating $scope.$on( "wall_preview.close" )', extend_timeout_action_deregistration);
						} else return console.warn('Ignoring timeout action');
					}

					if ($scope.show_zoom && !$scope.settings.views.zoom.show_must_go_on) {
						console.log( 'Should run timeout action, but zoom open' );

						if ($scope.settings.views.zoom.timeout_extend) {
							var extend_timeout_action_deregistration = $scope.$on( "zoom.close", function(){
								extend_timeout_action_deregistration();
								$scope.show.timeout_action();
							});

							return console.log( 'timeout_extend wanted. Initiating $scope.$on( "wall_preview.close" )', extend_timeout_action_deregistration);
						} else return console.warn('Ignoring timeout action');
					}

					if ($scope.show_wall_preview && !$scope.settings.views.wall_preview.show_must_go_on) {
						console.log( 'Should run timeout action, but wall_preview open' );

						if ($scope.settings.views.wall_preview.timeout_extend) {
							var extend_timeout_action_deregistration = $scope.$on( "wall_preview.close", function(){
								extend_timeout_action_deregistration();
								$scope.show.timeout_action();
							});

							return console.log( 'timeout_extend wanted. Initiating $scope.$on( "wall_preview.close" )', extend_timeout_action_deregistration);
						} else return console.warn('Ignoring timeout action');
					}

					$scope.show.timeout_action();
				};

				var curr_view = document.getElementById( "oeuvre_container_" + $scope.currentoeuvre );
				if (curr_view) {
					_timeout_opts.onPause   = function() {
						var audio_elem = curr_view.querySelector("audio[src]");
						if (audio_elem) audio_elem.pause();
					}
					_timeout_opts.onUnpause = function() {
						var audio_elem = curr_view.querySelector("audio[src]");
						if (audio_elem) audio_elem.play();
					}
				}
			}



			if (_timeout_fn && _timeout_ms > 0) {
				_timeout_opts.offset_ms = _timeout_ms_offset;

				console.log( "Initiating timeout, timeout: ", _timeout_ms + "ms" );
				console.log( "Initiating timeout, offset: ", (_timeout_opts.offset_ms||0) + "ms" );
				console.log( "Initiating timeout, fn:",       _timeout_fn );
				$rootScope.runningtimeout = new TimeoutRunner( _timeout_fn, _timeout_ms, _timeout_opts );
			} else {
				console.log( "No timeout action" );
			}
		}

		/**
		 * Siirrytään Alkusivulle
		 */
		function showStart() {
			console.debug( 'showStart()' );
			$scope.currentoeuvre = null;

			if ($scope.currentstate == 'initial') {
				
			} else if($scope.currentstate == 'start') {
				// Unable to move from start to start
			} else if ($scope.currentstate == 'end') {
				//end has no ability to do this
			} else if ($scope.currentstate == 'help') {
				//help has no ability to do this
			} else {

				handleOeuvrePreviousTransition(
					'#oeuvre_container_'+$scope.oeuvre_list[ $scope.oeuvre_index ].uid,
					null
				);

				$scope.oeuvre_index = 0;
				$scope.show_details = false;
				setCurrentState( 'start' );
				$scope.currentoeuvre = $scope.oeuvre_list[$scope.oeuvre_index].uid;
				$scope.start.initialize_action();
			}

			return $timeout();
		} // showStart();

		/**
		 * Siirrytään nykyistä seuraavaan diaan.
		 * Aloitusdian tapauksessa aloitetaan ensimmäisestä esityksen diasta 
		 * ja esityksen viimeisen dian tapauksessa Lopetusdiaan.
		 */
		function showNext() {
			console.debug( 'showNext()' );
			$scope.currentoeuvre = null;

			if ($scope.currentstate == 'initial') {
				
			} else if ($scope.currentstate == 'start') {
				
				var slide_index = 0;

				var slide = $scope.oeuvre_list[ slide_index ];

				if (!slide) return console.warn( "showNext(currentstate=start) :: there are no slides!" );

				console.log('moving from start to showcase');
				$scope.oeuvre_index = slide_index;
				$scope.oeuvre_list[$scope.oeuvre_index].show_details = false;
				handleOeuvreNextTransition(
					null,
					'#oeuvre_container_'+$scope.oeuvre_list[$scope.oeuvre_index].uid
				);
				setCurrentState( 'show_'+$scope.oeuvre_list[$scope.oeuvre_index].uid );
				$scope.currentoeuvre = $scope.oeuvre_list[$scope.oeuvre_index].uid;
			} else if ($scope.currentstate == 'end') {
				//end has no next
			} else if ($scope.currentstate == 'help') {
				//help has no next
			} else {

				var slide_index = ($scope.oeuvre_index || 0) + 1;

				var slide = $scope.oeuvre_list[ slide_index ];
					
				$scope.show_details = false;

				if (slide) {
					console.log('Showing next oeuvre');

					$scope.oeuvre_index = slide_index;

					$scope.oeuvre_list[$scope.oeuvre_index -1].show_details=false;

					handleOeuvreNextTransition(
						'#oeuvre_container_'+$scope.oeuvre_list[$scope.oeuvre_index -1 ].uid,
						'#oeuvre_container_'+$scope.oeuvre_list[$scope.oeuvre_index].uid
					);
					
					setCurrentState( 'show_'+$scope.oeuvre_list[$scope.oeuvre_index].uid );

					$scope.currentoeuvre = $scope.oeuvre_list[$scope.oeuvre_index].uid;

				} else {
					console.log( 'No more slides, showing end' );

					$scope.oeuvre_list[ $scope.oeuvre_index ].show_details = false;

					handleOeuvreNextTransition(
						'#oeuvre_container_'+$scope.oeuvre_list[ $scope.oeuvre_index ].uid,
						null
					);
					
					setCurrentState( 'end' );

					$scope.end.reached_end_action();
				}
			}

			return $timeout();
		} // showNext();

		/**
		 * Siirrytään nykyistä edelliseen diaan.
		 * Lopetusdian tapauksessa siittytään viimeiseen diaan.
		 * @TODO Ensimmäiseen diaan päätyessä ei siirrytä Aloitusdiaan 
		 */
		function showPrevious() {
			console.debug( 'showPrevious()' );
			$scope.currentoeuvre = null;

			if ($scope.currentstate == 'initial') {
			} else if ($scope.currentstate == 'start') {
			} else if ($scope.currentstate == 'end') {
				console.log('moving from end to showcase');
				$scope.oeuvre_index = $scope.oeuvre_list.length -1;
				$scope.oeuvre_list[$scope.oeuvre_index].show_details=false;

				handleOeuvrePreviousTransition( null, '#oeuvre_container_'+$scope.oeuvre_list[$scope.oeuvre_index].uid );

				setCurrentState( 'show_'+$scope.oeuvre_list[$scope.oeuvre_index].uid );
				$scope.currentoeuvre = $scope.oeuvre_list[$scope.oeuvre_index].uid
			} else if ($scope.currentstate == 'help') {
			} else {
				$scope.oeuvre_index--;
				$scope.show_details = false;

				if ($scope.oeuvre_list[$scope.oeuvre_index] == null) {
					console.log('No previous oeuvres, aborting');
					$scope.oeuvre_index++;
					handleOeuvrePreviousTransition( null, null );
					setCurrentState( 'show_'+$scope.oeuvre_list[$scope.oeuvre_index].uid );
					$scope.currentoeuvre = $scope.oeuvre_list[$scope.oeuvre_index].uid;
				} else {
					console.log('Showing previous oeuvre');
					$scope.oeuvre_list[$scope.oeuvre_index + 1].show_details=false;

					handleOeuvrePreviousTransition( '#oeuvre_container_'+$scope.oeuvre_list[$scope.oeuvre_index +1 ].uid, '#oeuvre_container_'+$scope.oeuvre_list[$scope.oeuvre_index].uid );
					
					setCurrentState( 'show_'+$scope.oeuvre_list[$scope.oeuvre_index].uid );
					$scope.currentoeuvre = $scope.oeuvre_list[$scope.oeuvre_index].uid;
				}
			}

			return $timeout();
		} // showPrevious();

		/**
		 * @function
		 * Suoritetaan kahden dian välillä siirtymäanimaatio
		 */
		function handleOeuvreNextTransition( outitem, initem, noFocus ) {
			console.debug( "handleOeuvreNextTransition()" );

			if ($scope.show.oeuvre_transition == 'slide') {
				if (outitem != null) {
					$(outitem).removeClass('oeuvre_transition_slide_in_right');
					$(outitem).removeClass('oeuvre_transition_slide_out_right');
					$(outitem).removeClass('oeuvre_transition_slide_out_left');
					$(outitem).addClass('oeuvre_transition_slide_out_left');
				}
				if (initem != null) {
					$(initem).addClass('oeuvre_transition_slide_in_right');
				}
			}

			handleOeuvreTransition( outitem, initem, noFocus );
		} // handleOeuvreNextTransition();

		/**
		 * @function
		 * Suoritetaan kahden dian välillä siirtymäanimaatio
		 */
		function handleOeuvrePreviousTransition( outitem, initem, noFocus ) {
			console.debug( "handleOeuvrePreviousTransition()" );

			if ($scope.show.oeuvre_transition == 'slide') {
				if (outitem != null) {
					$(outitem).removeClass('oeuvre_transition_slide_in_left');
					$(outitem).removeClass('oeuvre_transition_slide_in_right');
					$(outitem).removeClass('oeuvre_transition_slide_out_left');
					$(outitem).addClass('oeuvre_transition_slide_out_right');
				}
				if (initem != null) {
					$(initem).addClass('oeuvre_transition_slide_in_left');
				}
			}

			handleOeuvreTransition( outitem, initem, noFocus );
		} // handleOeuvrePreviousTransition();


		/**
		 * @function
		 * Suoritetaan kahden dian välillä siirtymäanimaatio
		 */
		function handleOeuvreTransition( outitem, initem, noFocus ) {
			console.log( "handleOeuvreTransition()" );

			$scope.currentoeuvre;

			if (outitem != null) {
				stopOeuvreViewAudio();
			}

			if (initem != null) {
				var in_item_uid = (initem.substr( 0, 18 ) == "#oeuvre_container_") && initem.substr( 18 );
				var oeuvre_settings = in_item_uid && $rootScope.settings.oeuvre_settings && $rootScope.settings.oeuvre_settings[ in_item_uid ] || {};

				var audioitem = $(initem).find('audio')[0];
				if (audioitem) {

					var audio_delay;
					if (oeuvre_settings.audio_delay != null) {
						audio_delay = oeuvre_settings.audio_delay;
					} else if ($scope.show.audio_delay != null) {
						audio_delay = $scope.show.audio_delay;
					}
					audio_delay = audio_delay || 0;

					$timeout(function(){
						var offset_ms = 0;

						if (oeuvre_settings.$$universal_slide_loop_start_time && oeuvre_settings.timeouttimems) try {
							offset_ms = (
									(window.SERVER_LOAD_TIME - parseInt( oeuvre_settings.$$universal_slide_loop_start_time ))
									+ (Date.now() - window.BROWSER_LOAD_TIME)
									) % oeuvre_settings.timeouttimems;

							try { offset_ms = oeuvre_settings.$$get_ms_in_global_loop(); } catch(e){}

							window.injectCurrentTimeSynchrotron( audioitem, offset_ms );

							audioitem.$$getCurrentTime = function(){ return oeuvre_settings.$$get_ms_in_global_loop() / 1000; };

						} catch(e) { console.warn( "Unable to initiate offset_ms for audio:", e ); }

						audioItemPlay( audioitem, offset_ms );
					}, audio_delay );
				}

				if (!noFocus) focusToPositionItem( in_item_uid );
			}
		} // handleOeuvreTransition();

		/**
		 * @function
		 * Pyritään käynnistämään audiotiedosto (mahdollisesti keskeltä)
		 */
		function audioItemPlay( audioitem, offset_ms, ignore_retry ) {
			
			if (!audioitem) return;
			
			if (!(offset_ms > 0)) offset_ms = 0;

			var stime = Date.now();

			var retry_audioItemPlay = function() {

				if (ignore_retry) return;

				try {
					if ($( audioitem ).parents( ".viewpanel" )[0]) {

						if (audioitem != $scope.current_slide.audioElem) {

							audioItemPlay( $scope.current_slide.audioElem, offset_ms + (Date.now() - stime), true );

							return;
						}
					}
				} catch (error) {}

				audioItemPlay( audioitem, offset_ms + (Date.now() - stime), true );
			}

			console.debug( "audioItemPlay( audioitem, offset_ms )", audioitem, offset_ms );

			try {
				if (audioitem.error) {
					console.warn( "Unable to play audio", audioitem.error );
				} else {
					audioitem.currentTime = offset_ms / 1000;

					$q.when(audioitem.play()).then(function() {

						try {
							setUserAudioPermission();
						} catch(e) {}

					}).catch(function( error ) {

						console.warn( "audioItemPlay() :: audioitem.play().catch()", error );

						if (error.name === "NotAllowedError") {

							askUserAudioPermission(function() {
								retry_audioItemPlay();
							});

						} else {
							console.error( "ERROR@audioItemPlay() :: Unable to play audio", error );
						}
					});

					console.debug( "audioItemPlay(), readyState =",   audioitem.readyState );
					console.debug( "audioItemPlay(), networkState =", audioitem.networkState );
				}
			} catch (error) {
				console.error( "ERROR@audioItemPlay() :: Unable to play audio", error );
			}

		} // audioItemPlay();

		/**
		 * @function
		 * Suoritetaan käyttäjältä kysely suostumuksesta audion toistamiseen
		 */
		function askUserAudioPermission( callback ) {

			if (askUserAudioPermission.notification && askUserAudioPermission.permissionExpires > Date.now()) {

				return console.info( "askUserAudioPermission() :: Asking aborted!" );

			} else {
				
				console.info( "askUserAudioPermission() :: Asking permission!" );
			}
				
			setUserAudioPermission();

			Notification.info({
				title: "Selain pyytää lupaa soittaa ääntä",
				message: 'Klikkaa salliaksesi äänien toistaminen. <button style="cursor: pointer; display: inline-block; font-weight: 400; text-align: center; vertical-align: middle; border-color: #007bff; box-sizing: border-box; color: #fff; background-color: #007bff; padding: .25rem .5rem; font-size: .875rem; line-height: 1.5; border-radius: .2rem;">Salli</button>',
				delay: 9999999, // Monta millisekuntia
				onClose: function( element ) {
			
					console.debug( "setUserAudioPermission.notification.onClick()" );

					// Varmistetaan, että tänne on päästy käyttäjän tahdosta eikä muust syystä
					if (element.hasClass( "killed" )) return;

					callback && callback();

				}
			}).then(function( scope ) {

				askUserAudioPermission.notification = scope;

				scope._templateElement.css( "opacity", 1 );
			});
		} // askUserAudioPermission();
	
		/**
		 * @function
		 * Merkitään käyttäjältä suostumus audion toistamiseen saaduksi
		 */	
		function setUserAudioPermission() {

			console.debug( "setUserAudioPermission()" );

			clearUserAudioPermission();

			askUserAudioPermission.permissionExpires = Date.now() + 2 * 60 * 1000;

		} // setUserAudioPermission();
		
		/**
		 * @function
		 * Tyhjennetään kysely käyttäjältä audion toistamiseksi
		 */	
		function clearUserAudioPermission() {

			console.debug( "clearUserAudioPermission()" );

			if (askUserAudioPermission.notification) {
				var notification = askUserAudioPermission.notification;

				$timeout(function() {

					notification._templateElement.addClass( "killed" );

					return notification.kill( true );

				}).catch(function( error ) {

					console.error( error );
				});
			}

			askUserAudioPermission.permissionExpires = null;
			askUserAudioPermission.notification = null;

		} // clearUserAudioPermission();

		/******************/

		/**
		 * @function
		 * Kohdennetaan dialistauksessa näkymä s.e. määrätty dia näkyy
		 */
		function focusToPositionItem( id ) {

			try {				
				var listitem  = $( '.position_item_' + id ).parent();
				var posi      = listitem[0].offsetLeft;
				var scroller  = $( listitem[0] ).parent().parent()[0];
				var firstitem = $( scroller ).find('li').first();

				$( scroller ).scrollTo( posi - listitem[0].offsetWidth - firstitem[0].offsetWidth, 0 );

			} catch (e) {}

		} // focusToPositionItem();

		/** @function
		 * Käskytetään diojen audiot pysäytettäväksi, mahdollisesti määrättyä lukuunottamatta
		 */
		function stopOeuvreViewAudio( containers, except ) {

			try {
				if (!containers) containers = "#main_container > .viewpanel.oeuvrepanel";

				$( containers ).find(".oeuvre_sound > audio[src]").each(function(){
					if (except && except == this) return;

					this.pause();
					this.currentTime = 0;

					injectCurrentTimeSynchrotron.removeSynchrotron( this );
				});
			} catch (error) {
				console.error( "stopOeuvreViewAudio() ::", error );
			}
		} // stopOeuvreViewAudio();

		/*********************************/

		$scope.$$animDiaStyleAttrs = {};
		$scope.$$animDiaRect = null;

		function initializeAnimations() {

			// Ruudun koon muuttuessa .anim_containerien koon pitää muuttua
			angular.element( window ).on( "resize", $$resetAnimDiaStyles );

			// Luodaan oma lohko tyyleille joilla käsitellään diojen animaatioita config.json'n pohjalta
			var sheet = document.createElement( 'style' );

			sheet.id = "customOeuvreAnimationsStylesheet";

			var animations_n = 0;

			for (var idx = 0; idx < $scope.oeuvre_list.length; idx++) {

				var item = $scope.oeuvre_list[ idx ].$settings;

				item.$hasAnimation = !!item.animation_name;

				if (item.$hasAnimation) {

					var css = "";

					var animation_duration = "10s";
					try {
						if ($scope.show.timeouttimems && !isNaN( parseInt( $scope.show.timeouttimems ))) {
							animation_duration = parseInt( $scope.show.timeouttimems ) + "ms";
						}
					} catch (error) {}
					if (item.animation_duration && !isNaN( parseInt( item.animation_duration ))) {
						animation_duration = parseInt( item.animation_duration ) + "s";
					} else if (item.timeouttimems && !isNaN( parseInt( item.timeouttimems ))) {
						animation_duration = parseInt( item.timeouttimems ) + "ms";
					}
					css += "animation-duration: " + animation_duration + "; ";

					if (item.animation_name) {
						css += "animation-name: "+ item.animation_name +"; ";
					}

					sheet.innerHTML += "#oeuvre_container_" + $scope.oeuvre_list[ idx ].uid + " .anim_container.anim > .animation { " + css + "}\n";

					animations_n++;
				}
			}

			document.body.appendChild( sheet );

			console.info( "Showcase have " + (animations_n || "no") +  " animated oeuvres!" );
		}


		// Tyhjennetään aiemmin animaatioita varten generoidut tiedot esim. ikkunan koon muuttuessa tai alustettaessa
		function $$resetAnimDiaStyles() {

			$scope.$$animDiaStyleAttrs = {};
			$scope.$$animDiaRect = null;

			var refDia = document.querySelector(".viewpanel.oeuvrepanel:not(.ng-hide) > .oeuvre_main > .oeuvre_image");

			if (refDia) {
				$scope.$$animDiaRect = refDia.getBoundingClientRect();
				console.debug( "$$animDiaRect:", $scope.$$animDiaRect );
			}
		}

		// Generoidaan teoksen animaatiota ympäröivän wrapperin koko style-attribuuttiin
		$scope.genAnimContainerStyleAttr = (function(){
			return function genAnimContainerStyleAttr( oeuvre ) {
				try {

					// Jos ei ole tiedossa animoitavan alan koko, päivitetään se
					if (!$scope.$$animDiaRect) $$resetAnimDiaStyles();
						
					// Turha jatkaa jos teos ei ole animoitavissa
					if ($scope.$$isAnimatableOeuvre( oeuvre )) {
			
						// Jos animoitavan dian tyylit on jo tiedossa, turha jatkaa
						if ($scope.$$animDiaStyleAttrs[ oeuvre.uid ]) return $scope.$$animDiaStyleAttrs[ oeuvre.uid ];

						/** @TODO: Alustetava jossain muualla!!! */
						if (oeuvre.$image_img_normal == null) {
							oeuvre.$image_img_normal = new Image();
							oeuvre.$image_img_normal.src = "/i/" + oeuvre.with.oeuvre.img_uid + "?size=normal";
						}

						// Jos on valmiudet tyylien määrittämiseen, hoidetaan homma
						if ($scope.$$animDiaRect && oeuvre.$image_img_normal && oeuvre.$image_img_normal.complete) {

							var size = genAnimDiaSize( $scope.$$animDiaRect, {
								width:  oeuvre.$image_img_normal.naturalWidth,
								height: oeuvre.$image_img_normal.naturalHeight
							});

							size = size.toFixed( 2 ) + "px";

							// Containerin on oltava neliö jotta animaatiossa käytetyt prosentit osuvat oikeisiin kohtiin
							$scope.$$animDiaStyleAttrs[ oeuvre.uid ] = { width: size, height: size };

							console.debug("$$animDiaStyleAttrs[ "+oeuvre.uid+" ]",  $scope.$$animDiaStyleAttrs[ oeuvre.uid ]);//, { ratio: ratio });
						}

					} else {
						$scope.$$animDiaStyleAttrs[ oeuvre.uid ] = {};
					}

					return $scope.$$animDiaStyleAttrs[ oeuvre.uid ];

				} catch (error) {
					console.error( error );
				}
			};

			function genAnimDiaSize( container, img ) {

				var container_ratio = container.width / container.height;
				var img_ratio       =       img.width / img.height;

				var min_size = Math.min( container.height, container.width );
				var max_size = Math.max( container.height, container.width );

				var size = min_size;

				/* Neliö-containerin tapauksessa oikea vastaus on containerin kokoinen neliö. */
				if (min_size != max_size) {

					/* Tarkastellaan erikseen korkeuttaan leveämmät containerit sekä päinvastoin */
					if (container.width > container.height) {
						if (container.width < container.height * img_ratio) {
							/* Jos kuvan leveys containerin korkeudella on containerin leveyttä suurempi -> container.width */
							size = container.width;
						} else {
							size = container.height * img_ratio;
						}
					} else {
						if (container.height < container.width / img_ratio) {
							/* Jos kuvan leveys containerin korkeudella on containerin leveyttä suurempi -> container.width */
							size = container.height;
						} else {
							size = container.width / img_ratio;
						}
					}

					/* Varmistetaan ettei koko voi olla containeria suurempi */
					size = Math.max( min_size, size );
					size = Math.min( max_size, size );
				}

				return size;
			}
		})();

		$scope.$$isAnimatableOeuvre = (function( animatableOeuvres ) {
			return function $$isAnimatableOeuvre( oeuvre ) {

				var is = animatableOeuvres[ oeuvre.uid ];

				// Tarkastetaan onko teoksella animaatiota ylipäätään
				if (is == null) try {

					is = oeuvre.$settings.$hasAnimation; //document.querySelector("#oeuvre_container_"+oeuvre.uid+">.oeuvre_main>.oeuvre_image").computedStyleMap().get("animation-name").value;

					if (is == 'none' || is == '') is = false;

					animatableOeuvres[ oeuvre.uid ] = is = !!is;

				} catch (e) { }

				// Tarkastetaan halutaanko enää animoida
				if (is) {
					if (oeuvre.$settings.$showCount != null) {
						if (angular.isNumber( oeuvre.$settings.animation_show_count_limit )) {

							if (oeuvre.$settings.animation_show_count_limit && oeuvre.$settings.$showCount > oeuvre.$settings.animation_show_count_limit) is = false;

						} else {

							if (oeuvre.$settings.$showCount > 1) is = false;
						}
					}
				}

				return is;
			}
		})({});

		
		(function( slidesImages ) {

			$scope.$$getSlideImageUrls      = getSlideImageUrls;
			$scope.$$getSlideImageNormalSrc = getSlideImageNormalSrc;
			$scope.$$getSlideImageLargeSrc  = getSlideImageLargeSrc;
			
			function getSlideImageNormalSrc( slide_id ) {

				if (slidesImages[ slide_id ]) {

					if (slidesImages[ slide_id ].$largeImageReady) return slidesImages[ slide_id ].large;

					if (slidesImages[ slide_id ].normal) return slidesImages[ slide_id ].normal;
				}

				return getSlideImageUrls( slide_id ).normal;
			}

			function getSlideImageLargeSrc( slide_id ) {

				if (slidesImages[ slide_id ] && slidesImages[ slide_id ].$largeImageReady) return slidesImages[ slide_id ].large;

				var src = getSlideImageUrls( slide_id ).large;

				if (slidesImages[ slide_id ]) {
					
					var image = slidesImages[ slide_id ].$largeImage;
						
					if (!image) {
						image = slidesImages[ slide_id ].$largeImage = new Image();
						image.src = src;
					}

					if (image && image.complete) {

						slidesImages[ slide_id ].$largeImageReady = true;
					}

					/*image = slidesImages[ slide_id ].$largeImage = toDataURL( urls.large, function( src ) {
						image = new Image();
						image.src = src;

						slidesImages[ slide_id ].$largeImageReady = true;
						slidesImages[ slide_id ].$largeImage = image;
						slidesImages[ slide_id ].large = image.src;
					});
					function toDataURL(url, callback) {
						var xhr = new XMLHttpRequest();
						xhr.onload = function() {
							var reader = new FileReader();
							reader.onloadend = function() {
								callback(reader.result);
							}
							reader.readAsDataURL(xhr.response);
						};
						xhr.open('GET', url);
						xhr.responseType = 'blob';
						xhr.send();
					}*/
				}

				return src;
			}
		
			function getSlideImageUrls( slide_id ) {

				var isettings = $scope.settings.oeuvre_settings[ slide_id ];

				if (!isettings || !isettings.$item) return;

				var urls = slidesImages[ slide_id ];
			   
				if (!urls) {

					if (isettings.$item.with && isettings.$item.with.oeuvre) {

						urls = slidesImages[ slide_id ] = {
							normal: '/i/' + (isettings.$item.with.oeuvre.img_uid || '') + '?size=normal',
							large:  '/i/' + (isettings.$item.with.oeuvre.img_uid || '') + '?size=large'
						};
					}
				}

				return angular.extend({
					// Fallback-asetukset
					
					normal: '/i/?size=normal',
					large:  '/i/?size=large'
				}, urls );
			}

		})({});

		/*********************************/


		/*********************************/

		function initHelp() {
			$scope.show_help  = false;
			$scope.open_help  = HelpApp_open;
			$scope.close_help = HelpApp_close;

			$scope.toggle_help = function(){
				console.debug( '$scope.toggle_help()' );
				if ($scope.show_help) {
					HelpApp_close();
				} else HelpApp_open();
			}

			function HelpApp_open(){
				if ($scope.show_help) return;
				console.debug( 'HelpApp_open()' );

				$scope.show_help = true;
				$rootScope.$broadcast( "help.open" );
			}

			function HelpApp_close() {
				if (!$scope.show_help) return;
				console.debug( 'HelpApp_close()' );

				$scope.show_help = false;
				$rootScope.$broadcast( "help.close" );
			}
		}

		/*********************************/

		function initZoom() {
			$scope.show_zoom  = false;
			$scope.open_zoom  = ZoomApp_open;
			$scope.close_zoom = ZoomApp_close;

			function ZoomApp_open() {
				if ($scope.show_zoom)  return;
				console.debug( 'ZoomApp_open()' );

				$scope.show_zoom = true;

				return $q(function( resolve, reject ) {
					try {
						var zoomcanvas = document.getElementById('zoomcanvas');
						var zoomcontext = zoomcanvas.getContext("2d");
						zoomcontext.clearRect( 0, 0, zoomcanvas.width, zoomcanvas.height );

						var screenheight = window.innerHeight;
						var screenwidth = window.innerWidth;

						var scalemultiplier = 1;
						var screensizemultiplier = 2;

						var zoomimage = new Image();
						zoomimage.onload = function () {
							
							var imgwidth = this.width;
							var imgheight = this.height;
							var targetwidth = imgwidth;
							var targetheight = imgheight;
							
							var imagescale = imgwidth / imgheight;
							var wantedwidth = screensizemultiplier * screenwidth;
							var wantedheight = screensizemultiplier * screenheight;

							if (targetwidth < wantedwidth) {
								var scaleincrease = wantedwidth / targetwidth;
								targetwidth = targetwidth * scaleincrease;
								targetheight = targetheight * scaleincrease;
							}
							if (targetheight < wantedheight) {
								var scaleincrease = wantedheight / targetheight;
								targetwidth = targetwidth * scaleincrease;
								targetheight = targetheight * scaleincrease;
							}
							
							zoomcanvas.width = targetwidth * scalemultiplier;
							zoomcanvas.height = targetheight * scalemultiplier;
							zoomcontext.drawImage(zoomimage, 0, 0,zoomcanvas.width, zoomcanvas.height);

							resolve();
						};
						zoomimage.onerror = reject;
						zoomimage.src = "/i/" + $scope.oeuvre_list[ $scope.oeuvre_index ].with.oeuvre.img_uid + "?size=large";
					} catch( err ) { reject( err ); }
				}).catch(function( err ){
					console.error( err );

					ZoomApp_close();
				});
			}

			function ZoomApp_close() {
				if (!$scope.show_zoom)  return;
				console.debug( 'ZoomApp_close()' );

				$scope.show_zoom = false;
				$rootScope.$broadcast( "zoom.close" );
			}
		}
	}]);
})();
